<div class="hotel-details-container d-flex flex-column gap-32">
  <p
    class="sr-only"
    [innerHTML]="(selectedHotel()?.rating || selectedHotel()?.starRating) + ' ' + _storeSvc.localeObj().tf_10_HotelDetails_hotelRating"
  ></p>

  @if (hotelDetailsImgs() && hotelDetailsImgs()?.length > 0) {
    <app-carousel [images]="hotelDetailsImgs()" [carouselConfig]="_storeSvc.propInfo().carouselConfig ?? {}"
    class="d-block"
    [customClass]="'rounded overflow-hidden'" />
  }

    <div class="hotel-info d-flex gap-4 flex-column">
      <div class="hotel-name-rating-address-container">
        <div class="hotel-name-rating-container d-flex align-items-center gap-2 flex-wrap justify-content-between">
          <h2 class="primary-text-color body-font font-weight-semibold text-break mb-0">
            {{ selectedHotel()?.name || selectedHotel()?.propertyName }}</h2>
          @if (selectedHotel()?.rating || selectedHotel()?.starRating) {
            <app-star-rating [rating]="selectedHotel()?.rating || selectedHotel()?.starRating" />
          }
        </div>
        @if (getFullAddress(); as address) {
          <div class="hotel-address base-font-size text-break font-weight-normal mt-2">
            {{ address }}
          </div>
        }
      </div>

      @let hotelDescription = selectedHotel()?.description || selectedHotel()?.longDescription || selectedHotel()?.shortDescription;
      @if (hotelDescription) {
        <p class="hotel-description mb-0 base-font-size text-break font-weight-normal">
          {{ hotelDescription }}
        </p>
      }

      @if (selectedHotel()?.hotelMainPhoneNumber || selectedHotel()?.hotelReservationPhoneNumber) {
        <div class="hotel-phone-numbers-container gap-1 d-flex flex-column">
          @if (selectedHotel()?.hotelMainPhoneNumber) {
            <div class="hotel-direct-phone-number">
              <p
                class="primary-text-color body-font base-font-size font-weight-normal mb-0"
                [innerHTML]="_storeSvc.localeObj().tf_10_HotelDetails_hotelDirect"
              ></p>
              <p class="primary-text-color body-font base-font-size font-weight-normal mb-0">:</p>
              <a
                class="txt-black text-decoration-none hotel-phone-number ps-1 text-break"
                [href]="
                  selectedHotel()?.hotelMainPhoneNumber.startsWith('+')
                    ? 'tel:' + selectedHotel()?.hotelMainPhoneNumber
                    : 'tel:+' + selectedHotel()?.hotelMainPhoneNumber
                "
              >
                {{ selectedHotel()?.hotelMainPhoneNumber }}
              </a>
            </div>
          }

          @if (selectedHotel()?.hotelReservationPhoneNumber) {
            <div class="hotel-reservation-container d-flex">
              <p
                class="mb-0 d-inline-block"
                [innerHTML]="_storeSvc.localeObj().tf_10_HotelDetails_hotelReservation"
              ></p>
              <p class="mb-0 d-inline-block">:</p>
              <a
                class="txt-black text-decoration-none hotel-phone-number ps-1 base-font-size text-break font-weight-normal"
                [href]="
                  selectedHotel()?.hotelReservationPhoneNumber.startsWith('+')
                    ? 'tel:' + selectedHotel()?.hotelReservationPhoneNumber
                    : 'tel:+' + selectedHotel()?.hotelReservationPhoneNumber
                "
              >
                {{ selectedHotel()?.hotelReservationPhoneNumber }}
              </a>
            </div>
          }
        </div>
      }
    </div>

  @let featureAmenitiesArray = featuredAmenities();
  @if (featureAmenitiesArray && featureAmenitiesArray?.length > 0) {
    <hr class="hr my-0 opacity-100" />
    <div class="hotel-amenities-container d-flex flex-column">
      <h3
        class="hotel-amenities-title mb-0 text-break large-font-size font-weight-semibold"
        [innerHTML]="_storeSvc.localeObj().tf_10_HotelDetails_hotelFeatures"
      ></h3>

      <app-amenities-list
        class="hotel-amenities-list"
        [amenities]="featuredAmenities()"
        [limitAmenities]="false"
      />
    </div>
  }

  @let commonRoomAmenitiesArray = commonRoomAmenities();
  @if (commonRoomAmenitiesArray && commonRoomAmenitiesArray?.length > 0) {
    <hr class="hr my-0 opacity-100" />
    <div class="hotel-amenities-container d-flex flex-column">
      <h3
        class="hotel-amenities-title mb-0 text-break large-font-size font-weight-semibold"
        [innerHTML]="_storeSvc.localeObj().tf_10_HotelDetails_roomsInclude"
      ></h3>

      <app-amenities-list
        class="hotel-amenities-list"
        [amenities]="commonRoomAmenities()"
        [limitAmenities]="false"
      />
    </div>
  }

  @if (selectedHotel()?.latitude && selectedHotel()?.longitude) {
    <app-map
      [coordinates]="{ lat: +selectedHotel()?.latitude, lng: +selectedHotel()?.longitude }"
      [zoomLevel]="selectedHotel()?.mapZoomLevel || 15"
      [showMap]="true"
      [hotelName]="selectedHotel()?.name"
    />
  }
</div>
